import ReactRouterPrompt from 'react-router-prompt'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

interface DirtyPromptProps {
  isDirty: boolean
}

export const DirtyPrompt = ({ isDirty }: DirtyPromptProps) => {
  return (
    <ReactRouterPrompt when={isDirty}>
      {({ isActive, onConfirm, onCancel }) => (
        <Dialog
          fullWidth
          maxWidth='sm'
          open={isActive}
          PaperProps={{
            sx: { width: '40%', maxWidth: '40%' },
          }}
        >
          <DialogTitle sx={{ pt: 5 }}>
            Þú ert með óvistaðar breytingar.
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText sx={{ my: 2 }}>
              Ertu viss um að þú viljir fara af síðu? <br />
              Breytingar verða þá ekki vistaðar.
            </DialogContentText>
            <DialogActions sx={{ mt: 4, px: 0 }}>
              <LoadingButton
                variant='contained'
                color='secondary'
                type='button'
                onClick={onCancel}
                sx={{ mr: 2 }}
              >
                Hætta við
              </LoadingButton>
              <LoadingButton
                variant='contained'
                color='primary'
                type='button'
                onClick={onConfirm}
              >
                Halda áfram
              </LoadingButton>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
    </ReactRouterPrompt>
  )
}
